import React from 'react';
import { useDispatch, useSelector } from 'react-redux'
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';
import { makeStyles, Theme } from '@material-ui/core/styles';
import Fade from '@material-ui/core/Fade';
import { SnackbarMessage, actionCreators } from '../store/AlertSnackbarStore';
import { ApplicationState } from '../store';
import { Button } from '@material-ui/core';
import { AlertTitle } from '@material-ui/lab';

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        width: '100%',
        '& > * + *': {
            marginTop: theme.spacing(2),
        },
    },
    close: {
        padding: theme.spacing(0.5),
    },
}))

export default function AlertSnackbar() {
    const snackPack = useSelector<ApplicationState, SnackbarMessage[]>(state => state.snackbar?.snackPack ?? [])
    const [open, setOpen] = React.useState(false);
    const [messageInfo, setMessageInfo] = React.useState<SnackbarMessage | undefined>(undefined);
    const dispatch = useDispatch()

    React.useEffect(() => {
        if (snackPack.length && !messageInfo) {
            // Set a new snack when we don't have an active one
            setMessageInfo({ ...snackPack[0] });
            dispatch(actionCreators.popMessage());
            setOpen(true);
        }
    }, [snackPack, messageInfo, open]);

    const handleClose = (event: React.SyntheticEvent | MouseEvent, reason?: string) => {
        setOpen(false);
    };

    const handleExited = () => {
        setMessageInfo(undefined);
    };

    const classes = useStyles()
    // 4.7 chars per word, 4 words per sec, show errors for longer, + .5 seconds minimum for users to notice
    const duration = ((messageInfo?.title.length ?? 0) + (messageInfo?.message.length ?? 0))
        / (4.7 * 4)
        * (messageInfo?.alertType === 'error' ? 1500 : 1000) + 500
    return (
        <>
            <Snackbar className={classes.root}
                key={messageInfo ? messageInfo.key : undefined}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                open={open}
                autoHideDuration={Math.min(30000, Math.max(1500, Math.ceil(duration)))}
                TransitionComponent={Fade}
                onClose={handleClose}
                onExited={handleExited}
            >
                <MuiAlert elevation={6} variant="filled" severity={messageInfo?.alertType} onClose={handleClose}>
                    <AlertTitle>{messageInfo?.title}</AlertTitle>
                    {messageInfo?.message}
                </MuiAlert>
            </Snackbar>
        </>
    )
}
